// [TODO] FID-1484 generalizar e implementar interface, 
import { states } from '@/shared/i18n/locales/pt-br/states.js'
export function validateState(state) {
    if (!state) return true

    return states.includes(state)
}